import { useFormikContext } from "formik";
import { makeStyles } from "@material-ui/core";
import classnames from "classnames";
import DropdownInput from "../../../../forms/custom/DropdownInput.react";

const useStyles = makeStyles(() => ({
  fieldLabel: {
    lineHeight: "13px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
}));

function FieldLabel() {
  const classes = useStyles();

  return (
    <div className={classnames("static-input-label", classes.fieldLabel)}>
      Which party should submit timesheets?
    </div>
  );
}

function DefaultTimesheetSubmissionParty() {
  const formContext = useFormikContext();

  return (
    <>
      <FieldLabel />
      <DropdownInput
        overrideStyle={{ width: "25%", maxWidth: "25%", marginBottom: "36px" }}
        id="defaultTimesheetSubmissionParty"
        value={formContext.values.temp.defaultTimesheetSubmissionParty}
        allowEmpty={false}
        onChange={(e) => {
          formContext.setFieldValue("temp.defaultTimesheetSubmissionParty", e.target.value);
        }}
        options={[{ label: "Use Company Default", value: "use_company_default" }, { label: "My Company", value: "client" }, { label: "Staffing Firm", value: "supplier" }]}
      />
    </>
  );
}

export default DefaultTimesheetSubmissionParty;